// Side-effect import: loads the package's type declarations so TypeScript applies
// the `declare module "leaflet" { class MarkerClusterGroup ... }` augmentation.
// Webpack may tree-shake this (sideEffects: false) but require() below ensures
// the module is always included in the bundle.
import '@kristjan.esperanto/leaflet.markercluster';

// Augmentation is now active — MarkerClusterGroup lives on 'leaflet'.
// Alias to avoid name collision with the `export const { MarkerClusterGroup }` below.
import type { MarkerClusterGroup as MCGType, MarkerClusterGroupOptions } from 'leaflet';

// tsconfig.app.json restricts "types" to ["google.maps"], excluding @types/node.
// webpack injects require() at runtime; this local declaration satisfies TypeScript.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const require: (module: string) => any;

// require() resolves the package's named ESM export 'MarkerClusterGroup'.
// eslint-disable-next-line @typescript-eslint/no-require-imports
const _mcg = require('@kristjan.esperanto/leaflet.markercluster') as {
  readonly MarkerClusterGroup: new (options?: MarkerClusterGroupOptions) => MCGType;
};

/** Runtime constructor — resolved from the package's named ESM exports. */
export const { MarkerClusterGroup } = _mcg;

/** Options accepted by MarkerClusterGroup. */
export type ClusterLayerOptions = MarkerClusterGroupOptions;

/**
 * Type alias preserved for call-site compatibility.
 * To revert when official leaflet.markercluster ships Leaflet 2.0 support:
 *   - Change the side-effect import + require() path to 'leaflet.markercluster'
 *   - No other changes needed anywhere.
 */
export type NativeClusterLayer = MCGType;
